import React from 'react';

const QuoteSection = () => {
  return (
    <section className="py-40 bg-gradient-to-b from-surface to-surface-container-lowest text-center relative">
      <div className="max-w-4xl mx-auto px-6">
        <span className="material-symbols-outlined text-6xl text-primary/20 mb-8 block">auto_stories</span>
        <h2 className="font-headline text-3xl md:text-5xl italic leading-relaxed text-on-surface mb-8">
          "The journey of a thousand miles begins with a single wingbeat, a solitary fin-stroke, or a quiet hoofprint in the dust."
        </h2>
        <p className="font-label uppercase tracking-[0.4em] text-xs text-primary">Digital Field Journal</p>
      </div>
    </section>
  );
};

export default QuoteSection;
